import { css } from '@emotion/react';
import Image from 'next/image';
import React from 'react';

import { MembershipDiscountTag } from '@/booking-membership/components/MembershipDiscountTag';
import { useCurrentBookingIncludesBundledMembership } from '@/booking-membership/hooks/use-current-booking-includes-bundled-membership.hook';
import { Box } from '@/box';
import { useTranslation } from '@/i18n';
import { Button } from '@/ui/controls';
import { Spacer } from '@/ui/spacing';
import { BodyCopy, Heading } from '@/ui/typography';

interface MoreInfoCardProps {
  name: string;
  description?: string;
  image: {
    source: string;
    id: string;
    altText: string;
  };
  url: string;
}

export const MoreInfoCard = (props: MoreInfoCardProps) => {
  const { t } = useTranslation();

  const isMembershipEnabled = useCurrentBookingIncludesBundledMembership();

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <Box position="relative">
        <Image
          alt={props.image.altText}
          src={props.image.source}
          width={1000}
          height={1000}
          style={{ width: '100%', aspectRatio: '1', objectFit: 'cover' }}
        />
        {isMembershipEnabled && (
          <Box css={{ position: 'absolute', top: '18px', left: '18px' }}>
            <MembershipDiscountTag
              discount={t('bookingMembership:roomRate.discountOff', {
                discount: '10%',
              })}
            />
          </Box>
        )}
      </Box>
      <Spacer s="m" />
      <div className="name">
        <Heading as="h6" style="heading6">
          {props.name}
        </Heading>
      </div>
      <Spacer s="xs" />
      <div className="description">
        <BodyCopy>{props.description}</BodyCopy>
      </div>
      <Spacer s="xl" />
      <div
        css={css`
          flex: 1;
        `}
      ></div>
      <Button
        onClick={() => {
          window.open(props.url);
        }}
      >
        {isMembershipEnabled
          ? t('bookingMembership:confirmation.restaurants.cta')
          : t('common:findOutMore')}
      </Button>
    </div>
  );
};
